var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-select',{attrs:{"clearable":"","outlined":"","return-object":"","hide-details":"","item-text":"nombre","items":_vm.items,"label":"Fase","dense":""},model:{value:(_vm.fase),callback:function ($$v) {_vm.fase=$$v},expression:"fase"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }